import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  DateRangeArgs,
  MedicalCensusArgs,
  ReportDownloadArgs,
  ReportGeneratedArgs
} from '../../../../models/reports';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  formatDatePickerValue,
  parseDatePickerValue
} from '../../../../utils/datepicker-value-parser';
import moment from 'moment';
import { DownloadFormatOption } from '../report-buttons/report-buttons.component';

@Component({
  selector: 'lib-medical-census',
  templateUrl: './medical-census.component.html',
  styleUrls: ['./medical-census.component.css'],
  standalone: false
})
export class MedicalCensusComponent implements OnInit {
  @Input()
  public clientCode: string;
  @Output()
  public reportGenerated = new EventEmitter<ReportGeneratedArgs>();
  @Output()
  public reportDownloadClicked = new EventEmitter<ReportDownloadArgs>();

  public form: UntypedFormGroup;
  public buttons: DownloadFormatOption[] = [DownloadFormatOption.CSV()];
  private readonly ENDPOINT = 'MedicalCensus';
  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    const now = formatDatePickerValue(new Date());
    this.form = this.fb.group({
      asOfDate: this.fb.control(now, Validators.required),
      includePickupFigures: this.fb.control(false)
    });
  }

  public generateReport() {
    const args = this._getModel();
    this.reportGenerated.emit({ args, endpoint: this.ENDPOINT });
  }

  public downloadReport(format: string) {
    const args = this._getModel();
    const formattedStartDate = moment(args.AsOfDate).format('MM-DD-YYYY');
    const now = moment().format('MMDDYYYY');
    this.reportDownloadClicked.emit({
      args,
      endpoint: this.ENDPOINT,
      filename: `Medical Census Report_${this.clientCode}_${formattedStartDate}_${now}.${format}`,
      format
    });
  }

  private _getModel() {
    const args: MedicalCensusArgs = {
      AsOfDate: parseDatePickerValue(this.form.get('asOfDate').value),
      IncludePickupFigures: this.form.get('includePickupFigures').value
    };
    return args;
  }
}
